export const DIALOG_DRAFTS_STORAGE_KEY = "dialogDraftsStore"
